import { render, staticRenderFns } from "./EmployeeSickWidget.vue?vue&type=template&id=968ee63e&"
import script from "./EmployeeSickWidget.vue?vue&type=script&lang=js&"
export * from "./EmployeeSickWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports